export default {
  training: {
    code: "Code",
    hours: "Nombre d'heures",
    hours_learning: "Nombre d'heures d'enseignement",
    public: "Public prévu",
    comment: "Commentaire",
    registrants_number: "Nombre d'inscrits",
    publish_success: "Référentiel publié avec succès !",
    publish_program_success: "Programme publié avec succès !",
    rncp: {
      nsf_codes: "Codes NSF",
      form_codes: "Formacodes",
      rome_codes: "Codes Rome",
      targeted_activities: "Activités visées",
      domains: "Domaines",
      industry_sector_and_types_job: "Secteur d'activité et types d'emplois",
      business_sectors: "Secteurs d'activité",
      types_of_jobs: "Types d'emplois",
      due_date: "Date d'échéance",
      previous_certification: "Ancienne certification",
      new_certification: "Nouvelle certification",
      editing_competency_framework: "Édition du référentiel de compétences",
      rncp_skills: "compétences RNCP",
      ai_suggestions: "suggestions IA",
      skills_related: "Compétences rattachées à ce bloc de compétences",
      missions_related: "Missions rattachées à ce bloc de compétences",
      ai_suggestions_related_skills: "Suggestions IA - Compétences complémentaires",
      ai_suggestions_related_missions: "Suggestions IA - Missions complémentaires",
      relaunch_ai: "Relancer (3 nouvelles)",
      triad: "Livret,",
      badge: {
        rome: "ROME",
        rncp: "RNCP",
        triad: "Livret alternant",
        job_offer: "offres d'emplois",
        offer: "offres",
        sources: "Sources",
        triads: "Livrets",
        confidence: "Confiance",
      },
      workflow: {
        skill_import_label: "Import compétences",
        enrichment_import_label: "Enrichissement IA",
        publish_import_label: "Publication",
        waiting_status_label: "À venir",
        pending_status_label: "En cours",
        finished_status_label: "Terminé",
        import_button_label: "Importer",
        enrichment_button_label: "Enrichir les compétences",
        publish_button_label: "Publier",
      },
      actions: {
        reimporting_skills: "Données existantes détectées",
      },
      modal: {
        text: "Comment souhaitez vous procéder avec le nouvel import ?",
        merge_button_title: "Fusionner",
        merge_button_text: "Conserve les données existantes et ajoute uniquement les nouvelles",
        crush_button_title: "Remplacer",
        crush_button_text: "Supprime toutes les données existantes et les remplace par les nouvelles",
        alert_title: "Une maquette existe déjà pour cette formation",
        alert_text: "Comment souhaitez-vous procéder avec les nouvelles données ?",
        submit: "Confirmer l'import",
      },
      alert: {
        empty_rncp_warning_text:
          "Pour commencer à importer des données et créer votre premier référentiel de compétence, vous devez indiquer un titre RNCP depuis le formulaire de configuration de la formation accessible par un administrateur uniquement.",
        referential_publish_title: "Publier un référentiel",
        referential_publish_sub_title: "Êtes-vous sûr de vouloir publier ce référentiel ?",
        error: "Quelque-chose n'a pas fonctionné, veuillez réessayer plus tard.",
        importing: "Données en cours d'import, veuillez patienter.",
        enriching: "Données en cours d'enrichissement, veuillez patienter.",
        update_rncp: "Pensez à mettre à jour le code RNCP dés nouvelle publication",
        rncp_sheet_import:
          "Veuillez procéder à l'import des compétences pour afficher les détails du titre RNCP de la formation.",
        rncp_skill_import:
          "Veuillez procéder à l'import des compétences pour commencer la configuration du référentiel de la formation.",
        due_date_in_month: "Échéance dans {month} mois",
        due_date_in_day: "Échéance dans {day} jours",
        empty_skills:
          "Aucune compétence pour le moment, veuillez en importer depuis les suggestions IA ou en ajouter une\n" +
          "                  manuellement en cliquant sur le bouton +",
        empty_missions:
          "Aucune mission pour le moment, veuillez en importer depuis les suggestions IA ou en ajouter une\n" +
          "                  manuellement en cliquant sur le bouton +",
        empty_suggestions: "Aucune suggestion, veuillez relancer l'IA pour en obtenir des nouvelles.",
        empty_block:
          "Aucun bloc de compétence pour le moment, veuillez en ajouter un\n" +
          "                  manuellement en cliquant sur le bouton +",
      },
      level: {
        niv3: "CAP/BEP (Niveau 3)",
        niv4: "BAC (Niveau 4)",
        niv5: "BAC+2 (Niveau 5)",
        niv7: "BAC+5 (Niveau 7)",
        niv8: "Doctorat (Niveau 8)",
      },
      source_detail: {
        criticality: {
          title: "Criticité",
          low: "À surveiller",
          medium: "Émergent",
          high: "Très émergent",
        },
        pertinence: "Score de pertinence",
        criteria: {
          title: "4 critères retenus",
          pertinence_f: "Fréquence dans les offres",
          pertinence_a: "Alignement sémantique",
          pertinence_p: "Proximité métier",
          pertinence_d: "Distinctivité",
        },
        justification: "Justification IA",
        referential_presence: "Présence dans les référentiels",
        source: {
          rome: "ROME",
          esco: "ESCO",
          rncp: "RNCP",
          offres: "Offres d'emplois",
          offre: "Offre d'emploi",
          livret: "Livret",
          marche: "Marché",
        },
        source_offers: "Offres sources",
        published_at: "Publiée le",
        view_offer: "Voir l'offre",
        present: "Présent",
        absent: "Absent",
        offers_count: "{jobOfferCount} offres sur {jobOfferTotal} analysées mentionnent cette {type}.",
      },
    },
    program: {
      model: "Maquette",
      required: "Obl/Opt",
      ects: "ECTS",
      coefficient_short: "Coeff.",
      ai_confidence: "Confiance IA",
      target_audience: "Public visé",
      prerequisites: "Pré-requis",
      training_targets: "Objectifs de la formation",
      informations: "Informations pratiques",
      general_informations: "Informations générales",
      graduation: "Diplôme",
      route: "Parcours",
      rncp_code: "Code RNCP",
      graduation_type: "Type de diplôme",
      total_volume: "Volume total",
      ects_credits: "Crédits ECTS",
      add_files: "Déposez vos fichiers",
      training_program: "Programme de formation",
      duration: "Durée",
      modality: "Modalité",
      pace: "Rythme",
      location: "Lieu",
      professionalOutcomes: "Débouchés",
      extension_accepted_message: "Seuls les fichiers PDF, DOC, DOCX, XLS, XLSX et MSWORD sont acceptés",
      steps: {
        import: {
          title: "Import du programme",
          button: "Importer",
        },
        publish: {
          title: "Publication du programme",
          button: "Publier",
        },
        incoming: "À venir",
        inprogress: "En cours",
        finished: "Terminé",
      },
      actions: {
        reimporting_program: "Réimporter le programme ?",
      },
      modal: {
        text: "Un programme existe déjà pour cette formation. Comment souhaitez-vous procéder ?",
        merge_button_title: "Conserver et compléter",
        merge_button_text: "Les données existantes seront conservées, les nouvelles seront ajoutées.",
        crush_button_title: "Remplacer complètement",
        crush_button_text: "Toutes les données existantes seront supprimées et remplacées.",
        alert_title: "Important",
        alert_text: "Cette action impactera les prochains programmes publiés et les formations associées.",
        submit: "Confirmer l'import",
        "general-info": "Modifier les informations générales",
        "target-audience": "Modifier le public visé et les pré-requis",
        objectives: "Modifier les objectifs de la formation",
        "practical-info": "Modifier les informations pratiques",
      },
      training_period: {
        heading: {
          code: "Code",
          label: "Intitulé",
          type: "Type",
          required: "Obl/Opt",
          hours: "Heures",
          ects: "ECTS",
          coef: "Coef.",
          actions: "Actions",
        },
      },
      alert: {
        importing: "Données en cours d'import, veuillez patienter.",
        empty_semester:
          "Aucun semestre pour le moment, veuillez en ajouter un\n" +
          "                  manuellement en cliquant sur le bouton +",
        empty_unit:
          "Aucune unité et aucun module pour le moment, veuillez en ajouter\n" +
          "                  manuellement en cliquant sur les boutons +",
        program_import: "Veuillez procéder à l'import du programme pour commencer la configuration de la maquette",
        file_uploaded_success: "Fichier importé avec succès | {count} fichiers importés avec succès",
        file_upload_error: "Erreur lors de l'importation des fichiers",
        note: "Note",
        note_text:
          "Ces informations ont été extraites automatiquement de la maquette PDF. Vous pouvez les modifier en cliquant sur l'icône crayon.",
        warning_points: "Points d'attention",
        warning_points_text: "3 modules sans code • 2 modules nécessitent une vérification",
        empty_general_informations:
          "Veuillez procéder à l'import du programme pour afficher les informations générales",
        program_publish_title: "Publier le programme de formation",
        program_publish_sub_title:
          "Êtes-vous sûr de vouloir publier ce programme de formation sur toutes les promotions ?",
        unit_missing_code: ({ plural, named }) =>
          plural([`${named("count")} unité sans code`, `${named("count")} unités sans code`]),
        subject_missing_code: ({ plural, named }) =>
          plural([`${named("count")} module sans code`, `${named("count")} modules sans code`]),
        unit_need_validation: ({ plural, named }) =>
          plural([
            `${named("count")} unité nécessite une vérification`,
            `${named("count")} unités nécessitent une vérification`,
          ]),
        subject_need_validation: ({ plural, named }) =>
          plural([
            `${named("count")} module nécessite une vérification`,
            `${named("count")} modules nécessitent une vérification`,
          ]),
        verification: "Données à vérifier",
        low_confidence_score:
          "L'IA a détecté ce module avec une confiance de {confidence}%. Veuillez vérifier et corriger les informations ci-dessous avant de valider.",
      },
    },
    contact: {
      detail: {
        title: ({ named }) => `Détail du contact ${named("name")}`,
      },
    },
    contract_list: "Liste des contrats",
    contacts: {
      success: "Contacts enregistrés avec succès !",
    },
    plan_contract: {
      baseline: 'Pour selectionner l\'année sur laquelle vous travaillez cliquez sur "activer"',
    },
  },
  employee: ({ plural }) => plural(["Salarié ", "Salariés"]),
};
